module.exports = __webpack_public_path__ + "img/once_ru.956c0794.png";